import React from "react";
import requiredImg from "../Images/sp.gif";

const TextField = (props) => {
  const AlterTextField = (e) => {
    props.ReceivedTextData({
      ...props.State,
      fieldName: e.target.name,
      fieldValue: e.target.value,
      file: e,
      event: e,
    });
  };

  return (
    <>
      <div className="field-container">
        {props.redMark === true ? (
          <label className="field-placeholder font-medium">
            {props.label}{" "}
            <img alt="Required" src={requiredImg} className="redboxRequired" />
          </label>
        ) : (
          <label className="field-placeholder font-medium">{props.label}</label>
        )}
        <input
          className="field-input"
          type={props.type ? props.type : "text"}
          id={props.id}
          disabled={props.disabled === true}
          name={props.id}
          value={props.value}
          onChange={(e) => AlterTextField(e)}
          maxLength={props.length}
        />
      </div>

      {props.requiredMsg !== false ? (
        <label className="requiredFld requiredtext">
          {props.requiredMsg === true ? "Required" : props.requiredMsg}{" "}
        </label>
      ) : (
        ""
      )}
    </>
  );
};

export default TextField;
